<!------------------------- header start ------------------------------>
<header >
<div class="nav-area d-none" >
  <nav class="navbar navbar-expand-lg ">
    <div class="container-fluid">
      <a class="navbar-brand ml-5" routerLink="/home"><img src="/assets/image/logo.svg" alt="Logo"></a>
      <button class="navbar-toggler navbar-dark" type="button" data-toggle="collapse" data-target="#navbarSupportedContent1" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent1">
        <ul class="navbar-nav mx-lg-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <a class="nav-link active" aria-current="page"  routerLink="/coverage">Coverage</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/learningCenter">Learning Center</a>
          </li>
          <li class="nav-item">
            <a class="nav-link"  routerLink="/about">About </a>
          </li>

        </ul>

      </div>
      <ul class="navbar-nav last-navbar ml-lg-auto ml-0 mb-2 mb-lg-0 user">

        <li class="nav-item">
          <a class="nav-link btn nav-btn" href="#">Get a quota</a>
        </li>
        <li class="nav-item ">
          <a class="nav-link" href="#"> <i class="far fa-user"></i> </a>
        </li>

      </ul>
    </div>
  </nav>
</div>
</header>
<router-outlet></router-outlet>

